module.exports = __webpack_public_path__ + "img/BuyAbilityImg0.95cb5dbb.png";